import React from 'react';
import { styled } from '@compiled/react';
import { useIntl } from '@atlassian/jira-intl';
import permissionErrorImg from '../../common/assets/permission-error.svg';
import { ErrorDisplay } from '../../common/ui/error-display';
import { messages } from './messages';

export { messages as permissionErrorMessages };

export const PermissionErrorView = () => {
	const intl = useIntl();

	return (
		<ErrorDisplay
			header={intl.formatMessage(messages.permissionErrorHeader)}
			description={intl.formatMessage(messages.permissionErrorDescription)}
			image={<Image src={permissionErrorImg} alt="" />}
		/>
	);
};

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const Image = styled.img({
	height: '100px',
	width: '145px',
});
